// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1200px){.modal-xl[data-v-bd5b3684]{max-width:1525px}}", ""]);
// Exports
module.exports = exports;
